import Footer from '../components/Footer';
import HeroCover from '../components/HeroCover';
import FeatureBanner from '../components/FeatureBanner';
import ProblemSpark from '../components/ProblemSpark';
import WhyNowSection from '../components/WhyNowSection';
import CraftJourneySection from '../components/CraftJourneySection';
import LifeChangingPracticeComponent from '../components/LifeChangingPracticeComponent';
import CaughtYourselfThinkingSection from '../components/CaughtYouselfThinkingSection';
import WhyThisBook from '../components/WhyThisBook';
import WhatIf from '../components/WhatIf';
import ProofSecond from '../components/ProofSecond';
import IntroducingParentalGuide from '../components/IntroducingParentalGuide';
import BonusSection from '../components/BonusSection';
import SpecialBonus from '../components/SpecialBonus';
import WhatIsIncluded from '../components/WhatIsIncluded';
import TableOfContent from '../components/TableOfContent';
import MeetSara from '../components/MeetSara';
import FrequentlyAskedQuestions from '../components/FrequentlyAskedQuestions';
import FreebieSuccess from '../components/FreebieSuccess';
import LimitedTimeOffer from '../components/LimitedTimeOffer';
import { Box, Container, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const ParentalGuide = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromFreeChapter = location.state && location.state.fromFreeChapter;
  const fromOrder = location.state && location.state.fromOrder;

  useEffect(() => {
    const shouldShow = fromFreeChapter || fromOrder;
    if (!shouldShow) return;
    (async () => {
      const Swal = (await import('sweetalert2')).default;
      const config = fromFreeChapter
        ? {
            title: '🎉 Freebie On The Way!',
            text: 'Congrats — your free chapter is being emailed now. While you wait, explore the parental guide resources below.',
            icon: 'success',
          }
        : {
            title: '✅ Payment Successful',
            text: 'Your ebook has been emailed to you. Enjoy exploring the parental guide below while you check your inbox.',
            icon: 'success',
          };
      await Swal.fire({
        ...config,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#d6b468',
        backdrop: true,
      });
      navigate('/happyus-ppkp', { replace: true });
    })();
  }, [fromFreeChapter, fromOrder, navigate]);

  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
      <Box sx={{ width: '100%' }} disableGutters>
        {/* Show LimitedTimeOffer only on redirected visits; hide FreebieSuccess */}
        {(fromFreeChapter || fromOrder) && <LimitedTimeOffer />}
        <HeroCover />
        <FeatureBanner />
        <ProblemSpark />
        <WhyNowSection />
        <CraftJourneySection />
        <LifeChangingPracticeComponent />
        <CaughtYourselfThinkingSection />
        <WhyThisBook />
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: { xs: 'flex-start', md: 'flex-start' },
          flexWrap: 'wrap',
          gap: 1.5,
          mb: 2,
          mt: 2,
        }}>
          <Typography
            variant="subtitle1"
            color="text.primary"
            sx={{ fontWeight: 600, whiteSpace: 'nowrap', mb: { xs: 0.5, sm: 0 } }}
          >
            Applauded by readers worldwide:
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              whiteSpace: 'nowrap',
              mt: { xs: 0.5, sm: 0 },
            }}
          >
            <span role="img" aria-label="star" style={{ fontSize: 22 }}>⭐</span>
            <span role="img" aria-label="star" style={{ fontSize: 22 }}>⭐</span>
            <span role="img" aria-label="star" style={{ fontSize: 22 }}>⭐</span>
            <span role="img" aria-label="star" style={{ fontSize: 22 }}>⭐</span>
            <span role="img" aria-label="star" style={{ fontSize: 22 }}>⭐</span>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500, ml: 1, whiteSpace: 'nowrap' }}
            >
              4.98
            </Typography>
          </Box>
        </Box>
        <WhatIf />
        <ProofSecond />
        <IntroducingParentalGuide />
        <BonusSection />
        {/* <SpecialBonus /> */}
        <WhatIsIncluded />
        <TableOfContent />
        <MeetSara />
        <FrequentlyAskedQuestions />
      </Box>
    </Box>
  );
};

export default ParentalGuide;
